import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { AuthenticationService } from '../services';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthenticationService);

    return next(req).pipe(
        catchError(err => {
            if (err.status === 401) {
                authService.logout();
                location.reload();
            }

            const error = err.error?.message || err.statusText;
            return throwError(() => error);
        })
    );
};
